/**
 * Situação do banner principal da configuracao de loja
 */
export enum MainBannerStatus {
  PUBLISHED = 'PUBLISHED', // Publicada
  NOT_PUBLISHED = 'NOT_PUBLISHED', // Não publicada
}

export const translateMainBannerStatus = (status: MainBannerStatus): string => {
  switch (status) {
    case MainBannerStatus.PUBLISHED:
      return 'Publicada';
    case MainBannerStatus.NOT_PUBLISHED:
      return 'Não publicada';
    default:
      return status;
  }
};

export const colorByMainBannerStatus: Record<MainBannerStatus, string> = {
  [MainBannerStatus.NOT_PUBLISHED]: 'red.500',
  [MainBannerStatus.PUBLISHED]: 'green.500',
};

export class MainBanner {
  status!: MainBannerStatus;
  title!: string;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  source_url!: string;
  image_url!: string;
  created_at!: string;
  updated_at!: string;
}
